export const truckBaseUrlString = `/routes/:routeId/truck/:truckId/trailer/:trailerId`;

// Legacy URL shape (pre-"unpowered trailer in URL"), kept ONLY as a redirect
// source. Drivers who were sitting on a /routes/:routeId/truck/:truckId URL
// when this over-the-air update arrives would otherwise land on a dead,
// unmatched route (no header, no logout). The redirect routes in App.tsx send
// them to the current shape (with trailer "null") instead. Safe to delete once
// telemetry shows no traffic hitting it.
export const legacyNoTrailerBaseUrlString = `/routes/:routeId/truck/:truckId`;

// Legacy URL shape (pre-"remove sessions from mobile app"), kept ONLY as a
// redirect source. Drivers who were sitting on a /routes/:routeId/sessions/
// :sessionId/truck/:truckId URL when this over-the-air update arrives would
// otherwise land on a dead, unmatched route (no header, no logout). The
// redirect routes in App.tsx send them to the current shape instead. Safe to
// delete once telemetry shows no traffic hitting it.
export const legacyTruckBaseUrlString = `/routes/:routeId/sessions/:sessionId/truck/:truckId`;
export const worktimeUrlString = `${truckBaseUrlString}/worktime`;
export const drivingUrlString = `${truckBaseUrlString}/driving`;
export const routesLoginUrl = "/routes/login";
export const routesLoginCompletedTrips = "/routes/login-completed-trips";

interface DriverPageUrlInput {
  routeId: string;
  truckId: string;
  // The unpowered trailer. Optional at login, so the URL segment is the
  // literal string "null" when none is selected.
  trailerId: string | null;
}

// Parses the :trailerId URL segment — it is the literal string "null" when no
// trailer was selected at login. Use this whenever the trailer id from the URL
// is sent to the server.
export const parseTrailerIdParam = (
  param: string | null | undefined
): string | null => (param && param !== "null" ? param : null);

const fillIn = (urlString: string, input: DriverPageUrlInput) => {
  return urlString
    .replace(":routeId", input.routeId.toString())
    .replace(":truckId", input.truckId.toString())
    .replace(":trailerId", input.trailerId ?? "null");
};

export const worktimeUrl = (input: DriverPageUrlInput) => {
  return fillIn(worktimeUrlString, input);
};

export const drivingUrl = (input: DriverPageUrlInput) => {
  return fillIn(drivingUrlString, input);
};
